import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import FeedbackRoundedIcon from '@mui/icons-material/FeedbackRounded'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { FullScreenCalloutProps } from './_props'
import { variantsProps } from './variants'
import sxs from './_sxs'

const FullScreenCallout: React.FC<FullScreenCalloutProps> = ({
    title,
    text,
    icon,
    iconAlignment = 'center',
    expandedContent = undefined,
    variant = 'WARNING',
    action = undefined,
    buttonName = undefined,
}) => {
    const [isExpanded, setIsExpanded] = React.useState(false)
    const variantSx = variantsProps[variant]

    const handleClick = () => {
        setIsExpanded(!isExpanded)
    }

    return (
        <Stack
            alignItems="stretch"
            justifyContent="space-between"
            flexDirection="row"
            gap="1rem"
            sx={[sxs.fullScreenCallout, variantSx.classes?.container]}
        >
            <Stack flexDirection="row" alignItems="center" gap="1.5rem" flex={1}>
                <Stack
                    flexDirection="row"
                    justifyContent={iconAlignment}
                    alignItems="center"
                    sx={[sxs.fullScreenCalloutIconContainer, variantSx.classes?.element]}
                >
                    {icon ?? <FeedbackRoundedIcon />}
                </Stack>
                <Stack justifyContent="center" sx={sxs.fullScreenCalloutContentContainer}>
                    <Typography sx={[sxs.fullScreenCalloutTitle, variantSx.classes?.element]}>{title}</Typography>
                    <Typography>{text}</Typography>
                    {expandedContent && (
                        <Button
                            variant="text"
                            sx={sxs.fullScreenCalloutMoreInfoButton}
                            endIcon={<ArrowDropDownIcon />}
                            onClick={handleClick}
                        >
                            En savoir plus
                        </Button>
                    )}
                    {isExpanded && <Typography sx={sxs.fullScreenCalloutExpandedContent}>{expandedContent}</Typography>}
                </Stack>
            </Stack>
            {action && (
                <Stack justifyContent="center">
                    <Button
                        sx={[sxs.fullScreenCalloutActionButtonBase, variantSx.classes?.button]}
                        endIcon={<ChevronRightIcon />}
                        onClick={action}
                    >
                        {buttonName}
                    </Button>
                </Stack>
            )}
        </Stack>
    )
}

export default FullScreenCallout
